import { render } from "./BlogArticleFull.vue?vue&type=template&id=2801318b"
import script from "./BlogArticleFull.vue?vue&type=script&lang=js"
export * from "./BlogArticleFull.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__